import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c(VDialog, {
    style: {
      zIndex: _vm.options.zIndex
    },
    attrs: {
      persistent: "",
      "max-width": "80%"
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.close.apply(null, arguments);
      }
    },
    model: {
      value: _vm.shown,
      callback: function callback($$v) {
        _vm.shown = $$v;
      },
      expression: "shown"
    }
  }, [_c(VCard, {
    staticClass: "card"
  }, [_c("div", {
    staticClass: "dialog-closer --t-2"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    on: {
      click: function click($event) {
        return _vm.close();
      }
    }
  })], 1), _c(VCardTitle, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v("Schedule New Maintenance")])]), _c("section", [_c(VDivider)], 1), _c("section", {
    staticClass: "start-pickers"
  }, [_c("h1", {
    staticClass: "title"
  }, [_vm._v("Plan Maintenance Period")]), _c("div", {
    staticClass: "quick-config-container"
  }, [_c("div", {
    staticClass: "quick-config-container-buttons start"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: "",
      small: ""
    },
    on: {
      click: function click($event) {
        return _vm.setStartQuickTime(5);
      }
    }
  }, [_vm._v(" In 5 min ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: "",
      small: ""
    },
    on: {
      click: function click($event) {
        return _vm.setStartQuickTime(15);
      }
    }
  }, [_vm._v(" In 15 min ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: "",
      small: ""
    },
    on: {
      click: function click($event) {
        return _vm.setStartQuickTime(30);
      }
    }
  }, [_vm._v(" In 30 min ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: "",
      small: ""
    },
    on: {
      click: function click($event) {
        return _vm.setStartQuickTime(60);
      }
    }
  }, [_vm._v(" In 1 hour ")])], 1)]), _c("div", {
    staticClass: "inputs"
  }, [_c(VMenu, {
    ref: "menuStartDate",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.startDate,
      transition: "scale-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    on: {
      "update:returnValue": function updateReturnValue($event) {
        _vm.startDate = $event;
      },
      "update:return-value": function updateReturnValue($event) {
        _vm.startDate = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c(VTextField, _vm._g(_vm._b({
          attrs: {
            "hide-details": "auto",
            label: "Start Date",
            "prepend-icon": "mdi-calendar",
            outlined: "",
            rules: [_vm.formRules.mustNotBeEmpty, _vm.formRules.mustBeDate]
          },
          model: {
            value: _vm.startDate,
            callback: function callback($$v) {
              _vm.startDate = $$v;
            },
            expression: "startDate"
          }
        }, "v-text-field", attrs, false), on))];
      }
    }]),
    model: {
      value: _vm.menuStartDate,
      callback: function callback($$v) {
        _vm.menuStartDate = $$v;
      },
      expression: "menuStartDate"
    }
  }, [_c(VDatePicker, {
    attrs: {
      "no-title": "",
      scrollable: ""
    },
    model: {
      value: _vm.startDate,
      callback: function callback($$v) {
        _vm.startDate = $$v;
      },
      expression: "startDate"
    }
  }, [_c(VSpacer), _c(VBtn, {
    attrs: {
      text: "",
      color: "primary"
    },
    on: {
      click: function click($event) {
        _vm.menuStartDate = false;
      }
    }
  }, [_vm._v("Cancel")]), _c(VBtn, {
    attrs: {
      text: "",
      color: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.$refs.menuStartDate.save(_vm.startDate);
      }
    }
  }, [_vm._v("OK")])], 1)], 1), _c(VTextField, {
    attrs: {
      "hide-details": "auto",
      outlined: "",
      label: "Start Time (hh:mm)",
      "prepend-icon": "mdi-clock-time-four-outline",
      rules: [_vm.formRules.mustNotBeEmpty, _vm.formRules.mustBeTime]
    },
    model: {
      value: _vm.startTime,
      callback: function callback($$v) {
        _vm.startTime = $$v;
      },
      expression: "startTime"
    }
  })], 1)]), _c("section", {
    staticClass: "duration-pickers"
  }, [_c("div", {
    staticClass: "quick-config-container duration"
  }, [_c("div", {
    staticClass: "quick-config-container-buttons"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: "",
      small: ""
    },
    on: {
      click: function click($event) {
        return _vm.setDurationQuickTime(5);
      }
    }
  }, [_vm._v(" During 5 min ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: "",
      small: ""
    },
    on: {
      click: function click($event) {
        return _vm.setDurationQuickTime(10);
      }
    }
  }, [_vm._v(" During 10 min ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: "",
      small: ""
    },
    on: {
      click: function click($event) {
        return _vm.setDurationQuickTime(30);
      }
    }
  }, [_vm._v(" During 30 min ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: "",
      small: ""
    },
    on: {
      click: function click($event) {
        return _vm.setDurationQuickTime(60);
      }
    }
  }, [_vm._v(" During 1 hour ")])], 1)]), _c("div", {
    staticClass: "inputs duration"
  }, [_c(VTextField, {
    attrs: {
      label: "Maintenance Duration",
      type: "number",
      min: "1",
      "hide-details": "auto",
      outlined: "",
      rules: [function (v) {
        return !!v || "Duration is required";
      }]
    },
    model: {
      value: _vm.duration,
      callback: function callback($$v) {
        _vm.duration = $$v;
      },
      expression: "duration"
    }
  }), _c(VSelect, {
    attrs: {
      items: _vm.durationUnits,
      "item-text": "label",
      "item-value": "id",
      label: "Unit",
      "hide-details": "auto",
      outlined: ""
    },
    model: {
      value: _vm.durationUnit,
      callback: function callback($$v) {
        _vm.durationUnit = $$v;
      },
      expression: "durationUnit"
    }
  }), _c("div", {
    staticClass: "result"
  }, [_c(VIcon, [_vm._v("mdi-arrow-right-thick")]), _c("div", {
    staticClass: "title-small"
  }, [_c("span", [_vm._v("End Time :")]), _c("span", [_vm._v(_vm._s(_vm.formattedEndDateTime ? _vm.formattedEndDateTime : "Nothing Yet"))])])], 1)], 1)]), _c("section", [_c("div", {
    staticClass: "inputs alert-time-before-maintenance"
  }, [_c(VTextField, {
    attrs: {
      label: "Display countdown to user before maintenance (minutes)",
      type: "number",
      min: "1",
      "hide-details": "auto",
      outlined: ""
    },
    model: {
      value: _vm.alertThresholdMinutes,
      callback: function callback($$v) {
        _vm.alertThresholdMinutes = $$v;
      },
      expression: "alertThresholdMinutes"
    }
  }), _c("div", [_vm._v("in Minutes (default 60m)")])], 1), _c("div", [_c("p", {
    staticClass: "text-italic"
  }, [_vm._v("1440 minutes = 1 day")])])]), _c("section", [_c(VDivider)], 1), _c("section", [_c("h1", {
    staticClass: "title mb-4"
  }, [_vm._v("User Groups Settings")]), _c("div", {
    staticClass: "quick-config-container"
  }, [_c("div", {
    staticClass: "quick-config-container-buttons"
  }, _vm._l(_vm.quickUserGroups.length, function (i) {
    return _c(VBtn, {
      key: i,
      staticClass: "dfwa-btn --small-2 secondary",
      attrs: {
        rounded: "",
        small: "",
        title: _vm.getQuickUserGroups(i)
      },
      on: {
        click: function click($event) {
          return _vm.setQuickUserGroups(i);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.getQuickUserGroupsName(i)) + " ")]);
  }), 1)]), _c("div", [_c(VAutocomplete, {
    attrs: {
      items: _vm.USER_GROUPS_ARRAY,
      "item-text": "name",
      "item-value": "id",
      label: "Select User Groups Affected by Maintenance",
      "hide-details": "auto",
      outlined: "",
      multiple: "",
      chips: "",
      clearable: "",
      "return-object": ""
    },
    model: {
      value: _vm.selectedUserGroups,
      callback: function callback($$v) {
        _vm.selectedUserGroups = $$v;
      },
      expression: "selectedUserGroups"
    }
  }), _c("p", {
    staticClass: "text-italic text-smaller mt-2"
  }, [_c(VIcon, {
    staticClass: "fa fa-exclamation mr-2",
    staticStyle: {
      color: "red"
    },
    attrs: {
      size: "1rem"
    }
  }), _vm._v(" Any user group not selected above will not be affected: they will not see the maintenance countdown, won’t receive any alerts, and will be able to work normally during the maintenance period. ")], 1), _c("p", {
    staticClass: "bold text-italic text-smaller mt-2"
  }, [_vm._v(' Recommended for most maintenance cases: keep the default selection as "Everyone" ')])], 1)]), _c("section", [_c("div", {
    staticClass: "quick-config-container description"
  }, [_c("div", {
    staticClass: "quick-config-container-buttons"
  }, _vm._l(_vm.quickDescriptions.length, function (i) {
    return _c(VBtn, {
      key: i,
      staticClass: "dfwa-btn --small-2 secondary",
      attrs: {
        rounded: "",
        small: "",
        title: _vm.getQuickDescription(i)
      },
      on: {
        click: function click($event) {
          return _vm.setQuickDescription(i);
        }
      }
    }, [_vm._v(" Description: " + _vm._s(_vm.getQuickDescriptionTitle(i)) + " ")]);
  }), 1)]), _c("div", [_c(VTextarea, {
    attrs: {
      "no-resize": "",
      rows: "3",
      label: "Schedule description",
      "hide-details": "auto",
      outlined: ""
    },
    model: {
      value: _vm.description,
      callback: function callback($$v) {
        _vm.description = $$v;
      },
      expression: "description"
    }
  })], 1)]), _c("section", [_vm.selectedUserGroups.length > 0 ? _c("div", [_c("div", [_c(VDataTable, {
    staticClass: "elevation-2",
    attrs: {
      headers: _vm.UserGroupsConfigHeader,
      items: _vm.selectedUserGroups,
      "items-per-page": -1,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "disable-sort": "",
      solo: ""
    },
    scopedSlots: _vm._u([{
      key: "item.canwork",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c("div", {
          staticClass: "flex"
        }, [_c(VCheckbox, {
          attrs: {
            "hide-details": "",
            dense: ""
          },
          model: {
            value: _vm.userGroupCanWorkCheckboxes[item.value],
            callback: function callback($$v) {
              _vm.$set(_vm.userGroupCanWorkCheckboxes, item.value, $$v);
            },
            expression: "userGroupCanWorkCheckboxes[item.value]"
          }
        })], 1)];
      }
    }, {
      key: "item.custom-description",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c("div", {
          staticClass: "flex"
        }, [_c(VTextarea, {
          staticClass: "custom-description",
          attrs: {
            dense: "",
            rows: "3",
            label: "Custom description",
            "hide-details": "auto",
            outlined: ""
          },
          model: {
            value: _vm.userGroupCustomDescriptions[item.value],
            callback: function callback($$v) {
              _vm.$set(_vm.userGroupCustomDescriptions, item.value, $$v);
            },
            expression: "userGroupCustomDescriptions[item.value]"
          }
        })], 1)];
      }
    }], null, true)
  })], 1)]) : _vm._e()]), _c(VCardActions, [_c(VSpacer), _c(VBtn, {
    staticClass: "dfwa-btn secondary --small",
    attrs: {
      rounded: "",
      color: "primary",
      text: ""
    },
    on: {
      click: _vm.close
    }
  }, [_vm._v(" Cancel ")]), _c(VBtn, {
    staticClass: "dfwa-btn highlight --small",
    attrs: {
      rounded: "",
      disabled: !_vm.isFormValid
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v(" Schedule ")])], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };